import React, { useEffect, useState } from "react";
import LoadingMain from "../../components/LoadingMain";
import Footer from "../footer";
import NavBar from "../navbar";

import ProfileIcon from "../../assets/profile.png";
import config from "../../config";

import * as contentful from 'contentful';
import PageList from "./pagesList";





export default function BlogMain() {



    const [pages, setPages] = useState([]);
    const [includes, setIncludes] = useState({});
    const [loading, setLoading] = useState(false);
    const [errResponse, setErrResponse] = useState("");

    const author = {
        name: 'Sid Alwar',
        role: 'Co-Founder',
        href: '#'
    }
    
  const client = contentful.createClient(config.contentfulConfig);

    
  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        client.getEntries({
          content_type: 'blog',
          include: 1,
          order: '-sys.updatedAt'
        })
          .then((entries) => {

            setPages(entries.items)
            setIncludes(entries.includes)
            return entries;
            
          })
          .then((entry) => {

          })
          .catch((error) => {
            setErrResponse(error.message)
            console.error('Error fetching data:', error);
            setLoading(false)
          })
          .finally(() => {
            setLoading(false); // Set loading state to false after fetch completes
          }
          );
  
      };

      
      

    fetchData();
  }, []);


  function getAssetImageUrl(id) {
    const asset = includes.Asset.find(asset => asset.sys.id === id);
    if (asset) {
      return `https:${asset.fields.file.url}`;
    }
    return null;
  }


    function BlogsView() {
        return (
            <div className="bg-white py-24 sm:py-32">
              <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                  <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
                    From the blog
                  </h2>
                  <p className="mt-2 text-lg/8 text-gray-600">Read more about music.</p>
                </div>
                <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                  

              <PageList pages={pages} includes={includes} />


                </div>
              </div>
            </div>
          )
        

    }


      // render the fetched Contentful data
      return (
        <>
        

        {/* {Navbar} */}
        <div style={{ position: 'relative', zIndex: 50 }}>
          <NavBar selected={"blog"}></NavBar>
        </div>


        {loading ? <LoadingMain />
            : <>{BlogsView()}</>
        }



            {/* Start block */}
            <section className="bg-gray-50 dark:bg-zinc-800">
                <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
                    <div className="max-w-screen-sm mx-auto text-center">
                        <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
                            Start your transfer for free
                        </h2>
                        <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">

                        </p>
                        <a
                            href={config.signupPath}
                            className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
                        >
                            Sign up
                        </a>
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
      );
    }
    